/*
document.addEventListener('variant:change', function (event) {
  const variant = event.detail.variant;
  if (!variant) return;

  const qty = window.variantInventories[variant.id];
  const deliveryTimes = window.variantDeliveryTimes;
  const isPreorderable = window.isProductPreorderable;

  // Zuweisung der Lieferzeiten
  const outOfStockTime = isPreorderable ? "Vorbestellung innerhalb DE möglich!" : deliveryTimes.default.out_of_stock;
  const inStockTime = deliveryTimes.custom.in_stock || deliveryTimes.default.in_stock;

  const infoElement = document.getElementById('lieferzeit-info');
  if (infoElement) {
    // Setze die Lieferzeit je nach Lagerbestand
    if (qty <= 0) {
      // Keine doppelte Ausgabe mehr
      infoElement.innerHTML = `<strong>Lieferzeit:</strong> ${outOfStockTime}`;
    } else {
      infoElement.innerHTML = `<strong>Lieferzeit:</strong> ${inStockTime}`;
    }
  }
});*/


document.addEventListener('variant:change', function (event) {
  const variant = event.detail.variant;
  if (!variant) return;

  // Alle Grundpreise verstecken
  document.querySelectorAll('.variant-grundpreis').forEach(function(el) {
    el.style.display = 'none';
  });

  // Passenden Block für die neue Variant-ID einblenden
  const sel = `.variant-grundpreis[data-variant-id="${variant.id}"]`;
  const activeBlock = document.querySelector(sel);
  if (activeBlock) {
    activeBlock.style.display = 'block';
  }

  // Größenskizze: Maße pro Variante umschalten
  document.querySelectorAll('.size-sketch__variant-info').forEach(function(el) {
    el.style.display = 'none';
  });
  const activeSizeSketch = document.querySelector(`.size-sketch__variant-info[data-variant-id="${variant.id}"]`);
  if (activeSizeSketch) {
    activeSizeSketch.style.display = '';
  }

  // Lieferzeit-Code
  const qty = window.variantInventories[variant.id];
  const deliveryTimes = window.variantDeliveryTimes;
  const isPreorderable = window.isProductPreorderable;
  const outOfStockTime = isPreorderable ? "Vorbestellung innerhalb DE möglich!" : deliveryTimes.default.out_of_stock;
  const inStockTime = deliveryTimes.custom.in_stock || deliveryTimes.default.in_stock;
  const infoElement = document.getElementById('lieferzeit-info');

  if (infoElement) {
    if (qty <= 0) {
      infoElement.innerHTML = `<strong>Vorbestellung:</strong> Lieferung vorraussichtlich Ende Juni `;
    } else {
      infoElement.innerHTML = `<strong>Auf Lager</strong> ${inStockTime}`;
    }
  }
});

document.querySelectorAll('.badge--primary').forEach(el => {
  if (el.textContent.trim() === '11% NEWSLETTER-Rabatt*') {
    el.classList.add('badge--primary--black-week');
  }
});


